<div class="economy">
  <mat-icon [ngStyle]="textStyle">paid</mat-icon>
  <div class="text"[ngStyle]="textStyle">{{ amount }}</div>
</div>
